export default __webpack_public_path__ + "static/GraphQL-85141f995270e140c219445e92193b30.svg";